var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8995 29.4079C19.4365 31.2327 16.2682 30.9891 12.514 30.9891C12.514 30.8548 12.5169 30.7214 12.5176 30.5873C12.5065 30.5876 12.4971 30.5938 12.486 30.5938L12.4824 30.593C12.4832 30.7252 12.486 30.8565 12.486 30.9891C8.73184 30.9891 5.5636 31.2327 3.10054 29.4079C0.637311 27.583 -0.46267 24.3919 0.180393 21.6564C3.87265 21.1798 7.45087 21.7982 9.91394 23.6231C10.5088 24.0638 10.9609 24.5614 11.3127 25.0983V15.0586C7.4601 14.4642 4.66463 10.9185 4.66463 6.93142V1.27392C4.66463 0.569663 5.50713 0.2169 5.99987 0.714974L8.68272 3.42703C9.0317 3.77979 9.61267 3.72161 9.88657 3.30654L11.8353 0.352091C12.1449 -0.117364 12.8274 -0.117364 13.1368 0.352091L15.0854 3.30654C15.3591 3.72176 15.9401 3.77979 16.2892 3.42703L18.972 0.714974C19.4648 0.2169 20.3073 0.569663 20.3073 1.27408V7.27137C20.3073 11.2337 17.4208 14.5064 13.6592 15.0798V25.1345C14.0143 24.583 14.4772 24.0742 15.086 23.6232C17.549 21.7984 21.1274 21.18 24.8195 21.6566C25.4626 24.392 24.3628 27.583 21.8995 29.4079Z",
    fill: "#4D8D33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_1372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloom);
export default __webpack_public_path__ + "static/media/bloom.43fee341bc0ac220c0bc781f60705772.svg";
export { ForwardRef as ReactComponent };